import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import trophy from "../images/trophy.png";
import { Box, Button, CircularProgress } from "@mui/material";
import "../css/WinnersList.css";
import confetti from "canvas-confetti";
import axios from "axios";
import { API_URL } from "./Constant";
import ScoreboardPopup from "./ScoreboardPopup";

// const API_URL = "http://localhost:5000/get_winners"; // Replace with your backend URL

const NextArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0094b8"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="arrow-icon"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const PrevArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#0094b8"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="arrow-icon"
  >
    <path d="M19 12H5M12 5l-7 7 7 7" />
  </svg>
);

const WinnersListSlider = () => {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [scoreboardData, setScoreboardData] = useState(null);
  const handleOpenScoreboard = async (category, played_date) => {
    try {
      const response = await axios.get(`${API_URL}/get_scoreboard`, {
        params: { category, played_date },
      });
      const formattedData = response.data.map((player) => ({
        ...player,
        time: new Date(player.played_date).toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true, // Display in AM/PM format
          timeZone: "Asia/Kolkata",
        }),
      }));
      setScoreboardData(formattedData);
      setOpen(true);
    } catch (error) {
      console.error("Error fetching scoreboard:", error);
    }
  };

  const category = localStorage.getItem("RapidGame");

  useEffect(() => {
    if (!category) {
      setLoading(false); // Stop loading if no category is found
      return;
    }

    const fetchWinners = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/get_winners?category=${category}`,
        );
        console.log(response.data);
        const formattedWinners = response.data.map((winner, index) => ({
          name: winner.player_name,
          day: `Day ${index + 1}`,
          image: trophy,
          players: winner.total_players,
          played_date: winner.played_date,
        }));
        setWinners(formattedWinners);
      } catch (err) {
        console.error("Error fetching winners:", err);
        // setError("Failed to load winners.");
      } finally {
        setLoading(false);
      }
    };

    fetchWinners();
  }, [category]);

  return (
    <>
      {loading ? (
        <CircularProgress sx={{ color: "#0094b8", margin: "auto" }} />
      ) : error ? (
        <p style={{ color: "red", textAlign: "center" }}>{error}</p>
      ) : winners.length > 0 ? (
        <div
          className="carousel-container"
          style={{
            background: "linear-gradient(to bottom, #D7DFE2, #96A4A7, #65787E)",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            height: "100%",
          }}
        >
          {/* Custom Navigation Buttons */}
          <div
            className="swiper-button-prev"
            sx={{ position: "absolute", left: "2%", zIndex: 10 }}
          >
            <PrevArrow />
          </div>

          <Box
            sx={{
              width: "90%",
              display: "flex",
              height: "fit-content",
              overflow: "visible",
              alignItems: "center",
            }}
          >
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              spaceBetween={10} // Default space between slides
              breakpoints={{
                320: {
                  slidesPerView: 1, // Show only 1 slide on mobile
                  spaceBetween: 0, // Add space between slides
                  effect: "slide", // Use slide effect instead of coverflow on mobile
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                  effect: "coverflow", // Enable coverflow on tablets and larger screens
                  coverflowEffect: {
                    rotate: 0,
                    stretch: -20,
                    depth: 150,
                    modifier: 1.5,
                    slideShadows: false,
                  },
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: -80, // Overlap for larger screens
                  effect: "coverflow",
                  coverflowEffect: {
                    rotate: 0,
                    stretch: -50,
                    depth: 200,
                    modifier: 1.5,
                    slideShadows: false,
                  },
                },
              }}
              coverflowEffect={{
                rotate: 0,
                stretch: -50,
                depth: 200,
                modifier: 1.5,
                slideShadows: false,
              }}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              modules={[EffectCoverflow, Navigation, Autoplay]}
              className="mySwiper"
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            >
              {winners.map((winner, index) => (
                <SwiperSlide key={index}>
                  <div
                    className={`card ${index === activeIndex ? "active" : ""}`}
                    style={{
                      background:
                        index === activeIndex
                          ? "linear-gradient(135deg, #415C67, #007b9e)"
                          : "linear-gradient( #005D7C, #0D8CAF, #22B8DB)",
                      color: index === activeIndex ? "#FFFFFF" : "#000000",
                      borderRadius: "10px", // Ensure border radius is applied
                      overflow: "hidden", // Ensure content doesn't overflow
                      width: "90%", // Set a smaller width for mobile devices
                      maxWidth: "300px", // Limit maximum width for mobile
                      margin: "0 auto", // Center the slide
                    }}
                  >
                    <div className="card-header">
                      <h2 className="congrats">
                        🎉 {category} {winner.day} 🎉
                      </h2>
                      <h3 className="day">Winner: {winner.name}</h3>
                    </div>
                    <div className="card-content">
                      <p className="total-players">
                        Total Players: {winner.players}
                      </p>
                      {/* Play Demo Button */}
                      <Button
                        variant="contained"
                        onClick={() => {
                          window.location.href = "/play-demo-game";
                          localStorage.setItem(
                            "playDemoDate",
                            winner.played_date,
                          );
                          localStorage.setItem(
                            "DemoCategory",
                            localStorage.getItem("RapidGame"),
                          );
                          localStorage.removeItem("RapidGame");
                        }}
                        sx={{
                          width: "80%",
                          mt: 2,
                          fontWeight: "bold",
                          fontSize: "1rem",
                          px: 4,
                          py: 1,
                          borderRadius: 2,
                          color: index === activeIndex ? "#FFFFFF" : "#000000",
                          background:
                            "linear-gradient(135deg, #DC720C, #F5AD01)", // Dark Turquoise
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #DC720C, #F5AD01)",
                          }, // Light Sea Green
                        }}
                      >
                        Play Demo
                      </Button>

                      <Button
                        variant="contained"
                        onClick={() =>
                          handleOpenScoreboard(category, winner.played_date)
                        }
                        sx={{
                          width: "80%",
                          mt: 2,
                          fontWeight: "bold",
                          fontSize: "1rem",
                          px: 4,
                          py: 1,
                          borderRadius: 2,
                          color: index === activeIndex ? "#FFFFFF" : "#000000",
                          background:
                            "linear-gradient(135deg, #A21351, #FF59A3)",
                          "&:hover": {
                            background:
                              "linear-gradient(135deg, #A21351, #FF59A3)",
                          }, // Hot Pink
                        }}
                      >
                        Scoreboard
                      </Button>
                      <ScoreboardPopup
                        open={open}
                        onClose={() => setOpen(false)}
                        scoreboardData={scoreboardData}
                      />
                    </div>
                    <div className="card-footer">
                      <img
                        src={winner.image}
                        alt="Trophy"
                        style={{ width: "140px", height: "140px" }}
                        className="trophy"
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>

          {/* Custom Navigation Buttons */}
          <div
            className="swiper-button-next"
            style={{ position: "absolute", right: "2%", zIndex: 10 }}
          >
            <NextArrow />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default WinnersListSlider;
